import React from 'react';

export default ({ handleSortClick, order, sortedBy }) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('id')} _width_pc_8`}
        onClick={handleSortClick('id')}
      >
        <div>ID</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('submissionDate')} _width_pc_8`}
        onClick={handleSortClick('submissionDate')}
      >
        <div>Submission Date</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('componentType')} _width_pc_12`}
        onClick={handleSortClick('componentType')}
      >
        <div>Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses(
          'description'
        )} list-scene__table-row-element_place_filler`}
        onClick={handleSortClick('description')}
      >
        <div>Component Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('applicationStatus')} _width_pc_12`}
        onClick={handleSortClick('applicationStatus')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div className='list-scene__table-header-element _width_pc_12' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/List/TableHeader.jsx